<template>
    <div class="space-y-3 rounded-lg border border-blue-200 bg-blue-50/50 p-3">
        <div class="flex items-center gap-1.5">
            <span class="text-sm font-medium text-slate-800">Email Finder</span>
            <UTooltip :text="tooltip" :ui="{ content: 'max-w-xs h-auto', text: 'whitespace-normal' }">
                <button type="button" aria-label="About Email Finder" class="inline-flex">
                    <UIcon name="i-heroicons-information-circle" class="w-4 h-4 text-blue-500" />
                </button>
            </UTooltip>
        </div>
        <p class="text-xs text-slate-500">We verify every uploaded email address before sending. Finding an address does not guarantee it is eligible for outreach.</p>
        <UCheckbox v-model="enrichEmail" label="Find missing email addresses" :disabled="disabled" @click="handleDisabledClick" />
        <UCheckbox v-model="replaceInvalidEmail" label="Find a replacement for invalid uploaded emails" :disabled="disabled" @click="handleDisabledClick" />
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{ disabled?: boolean }>();
const emit = defineEmits<{ requestUnlock: [] }>();
const enrichEmail = defineModel<boolean>('enrichEmail');
const replaceInvalidEmail = defineModel<boolean>('replaceInvalidEmail');

const tooltip = computed(() => {
    if (enrichEmail.value && replaceInvalidEmail.value) {
        return 'We verify every email address you uploaded. For absent or invalid email addresses, we’ll try to find their email address for you.';
    }
    if (replaceInvalidEmail.value) {
        return 'We verify every email address you uploaded. For invalid email addresses, we’ll try to find a replacement. Missing email addresses will not be enriched.';
    }
    if (enrichEmail.value) {
        return 'We verify every email address you uploaded. For absent email addresses, we’ll try to find their email address for you. Invalid uploaded emails will not be replaced.';
    }
    return 'We verify every email address you uploaded. Missing email addresses will not be enriched, and invalid uploaded emails will not be replaced.';
});

function handleDisabledClick(event: Event) {
    if (!props.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    emit('requestUnlock');
}
</script>
